<template lang="pug">
  v-container(fliud class="pt-0 px-0")
    v-layout(wrap)
      v-flex(xs12)
        Filters
      v-flex(xs12, v-if="viewType === 'map'")
        AdvertsMap(:advertsList="advertsList")
      v-flex(xs12, md9, v-if="viewType === 'list'")
        v-row(no-gutters)
          AdvertsListItem(
            v-for="(item, index) in advertsList",
            :key="index",
            :advertItem="item")
        v-row(v-if="count")
          v-col
            Pagination(v-if="count > 1", :page="page", :count="count", @change-page="setPage")
      v-flex(md3 class="pl-5 d-none d-md-block" v-if="viewType === 'list'")
        div(class="banner")
          v-img(:src="require('@/assets/banners/banner-advert-page-vertical.jpg')" style="border-radius: 6px;")
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'AdvertList',
  data: () => ({
    page: 1,
    items: 25
  }),
  components: {
    Filters: () => import('@/components/Filters'),
    AdvertsListItem: () => import('@/components/Adverts/AdvertsListItem'),
    Pagination: () => import('@/components/common/Pagination'),
    AdvertsMap: () => import('@/views/AdvertsMap')
  },
  computed: {
    ...mapState({
      advertsList: state => state.advertsList,
      viewType: state => state.viewType
    }),
    count() {
      return Math.ceil(this.$store.state.countAdverts / this.items)
    }
  },
  created() {
    this.$store.dispatch('GET_ADVERTS_LIST')
  },
  methods: {
    setPage(value) {
      this.page = value
      const skip = value * this.items
      this.$store.dispatch('GET_ADVERTS_LIST', skip)
    }
  }
}
</script>

<style lang="scss" scoped>
/*.banner {*/
/*  position: -webkit-sticky; !* Safari *!*/
/*  position: sticky;*/
/*  top: 1rem;*/
/*}*/
</style>
